import { CommonModule, NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";

import { BackButtonComponent } from "@hermes/aphrodite/back-button";
import {
    CarouselComponent,
    CarouselPartDirective,
} from "@hermes/aphrodite/carousel";
import {
    ExpansionPanelComponent,
    ExpansionPanelPartDirective,
} from "@hermes/aphrodite/expansion-panel";
import { PriceComponent } from "@hermes/aphrodite/price";
import { SvgIconComponent } from "@hermes/aphrodite/svg";
import { VideoComponent } from "@hermes/aphrodite/video";
import { ImageResizerModule } from "@hermes/fragments/image-resizer";

import { PersonalizeLabelComponent } from "@hermes/fragments/personalize-label";

import { SpaceSeparatorPipeModule } from "@hermes/fragments/product-utils";
import { StoryBehindModule } from "@hermes/fragments/story-behind";
import { VtoCallToActionComponent } from "@hermes/fragments/vto-button";
import {
    ProductImageSeoUrlPipeModule,
    ProductPageFacade,
} from "@hermes/states/product-page";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";
import { I18nAssetAttributeDirectiveModule } from "@hermes/utils-generic/i18n-asset-attribute";
import { RouterServiceModule } from "@hermes/utils-generic/services/router";

import { ImagesGalleryComponent } from "./components/images-gallery/images-gallery.component";
import { ProductInfoAttributesComponent } from "./components/product-info-attributes/product-info-attributes.component";
import { ProductInfoDescriptionComponent } from "./components/product-info-description/product-info-description.component";
import { ProductInfoFooterComponent } from "./components/product-info-footer/product-info-footer.component";
import { ProductInfoHeaderComponent } from "./components/product-info-header/product-info-header.component";
import { ProductPageCrossSellComponent } from "./components/product-page-cross-sell/product-page-cross-sell.component";
import { ProductPageGridComponent } from "./components/product-page-grid/product-page-grid.component";
import { ProductPageGridItemComponent } from "./components/product-page-grid-item/product-page-grid-item.component";
import { ProductTemplateComponent } from "./components/product-template/product-template.component";
import { ProductTogglesComponent } from "./components/product-toggles/product-toggles.component";
import { ImageGalleryScrollDirective } from "./directives/images-gallery-scroll.directive";

@NgModule({
    imports: [
        ImageResizerModule,
        PersonalizeLabelComponent,
        PriceComponent,
        CommonModule,
        RouterServiceModule,
        SrOnlyNoSnippetDirective,
        CarouselComponent,
        CarouselPartDirective,
        VtoCallToActionComponent,
        CommonModule,
        BackButtonComponent,
        StoryBehindModule,
        ProductImageSeoUrlPipeModule,
        I18nAssetAttributeDirectiveModule,
        SvgIconComponent,
        VideoComponent,
        ExpansionPanelComponent,
        ExpansionPanelPartDirective,
        TranslateModule,
        SpaceSeparatorPipeModule,
        NgOptimizedImage,
    ],
    providers: [ProductPageFacade],
    declarations: [
        ProductPageGridItemComponent,
        ProductPageGridComponent,
        ProductPageCrossSellComponent,
        ProductTemplateComponent,
        ProductTogglesComponent,
        ProductInfoFooterComponent,
        ProductInfoAttributesComponent,
        ProductInfoDescriptionComponent,
        ProductInfoHeaderComponent,
        ImagesGalleryComponent,
        ImageGalleryScrollDirective,
    ],
    exports: [
        ProductPageGridItemComponent,
        ProductPageGridComponent,
        ProductPageCrossSellComponent,
        ProductTogglesComponent,
        ProductInfoFooterComponent,
        ProductInfoAttributesComponent,
        ProductInfoDescriptionComponent,
        ProductInfoHeaderComponent,
        ProductTemplateComponent,
        ImagesGalleryComponent,
        ImageGalleryScrollDirective,
    ],
})
export class ProductPageModule {}
